<form [formGroup]="projectDetailForm" class="new-proposal__fields new-proposal__fields--project-details">
    <h3 class="left" i18n="@@proposals.project_details">Project Details</h3>
    <div class="new-proposal__fields__wrap">  
        <div class="new-proposal__fields__wrap--content">
            <fieldset class="no-label" [ngClass]="{'has-error': submitted && projectDetailForm.get('title').errors}">
                <input type="text" formControlName="title" name="design-used" id="design-used" class="design-used" i18n-placeholder="@@proposals.project_title" placeholder="Project Title" />
                <span class="field-error" i18n="@@error.required">Required</span>
            </fieldset>
            <fieldset class="no-label" [ngClass]="{'has-error': submitted && projectDetailForm.get('description').errors}">
                <textarea class="large" formControlName="description" i18n-placeholder="@@proposals.description" placeholder="Description"></textarea>
                <span class="field-error" i18n="@@error.required">Required</span>
            </fieldset>
            <fieldset>
                <textarea class="normal" formControlName="comments" i18n-placeholder="@@proposals.other_comment" placeholder="Other comments"></textarea>
            </fieldset>
        </div>
        <div class="new-proposal__fields__wrap--side">
            <div class="new-proposal__fields--project-details__sidebar">
                <div class="new-proposal__fields--project-details__sidebar--content">
                    <div class="new-proposal__fields--project-details__sidebar--contentInner">
                        <label i18n="@@proposals.reference_files">Reference Files</label>
                        <label for="file" class="tu-btn-circular transparent">
                            <svg width="14" height="14" viewBox="0 0 14 14">
                                <g fill="none" fill-rule="evenodd" class="svg-stroke" stroke-linecap="square" stroke-width="2">
                                    <path d="M1 7h12M7 1v12"/>
                                </g>
                            </svg>
                        </label>
                        <input class="d-none" type="file" id="file" multiple="true" (change)="handleFileInput($event.target.files)" #file>
                    </div>
                    <div *ngFor="let file of files; index as $index" class="new-proposal__fields--project-details__sidebar--contentInner link-container">
                        <span class="filename" [attr.title]="file.name">{{ file.name }}</span>
                        <div class="persentage-wrap">
                            <span class="persentage">{{ file.size | fileSize }}</span>
                            <a (click)="removeFile($index)" href="javascript:void(0)" class="tu-icon-cancel cancel"><strong>x</strong></a>
                        </div>
                    </div>
                </div>

                <div class="new-proposal__fields--project-details__sidebar--content">
                    <div class="new-proposal__fields--project-details__sidebar--contentInner">
                        <label i18n="@@proposals.links_to_inspiration">Links to Inspiration</label>
                        <form [formGroup]="inspirationLinkForm" class="input-wrap inspiration_links" (ngSubmit)="addLink()">
                            <fieldset class="no-label mb-0" [ngClass]="{'has-error': linkSubmitted && inspirationLinkForm.get('link').errors}">
                                <input type="text" formControlName="link" i18n-placeholder="@@proposals.paste_link_here" placeholder="Paste your link here…" />
                                <a (click)="addLink()" href="javascript:void(0)" class="tu-btn-circular transparent">
                                    <svg width="14" height="14" viewBox="0 0 14 14">
                                        <g fill="none" fill-rule="evenodd" class="svg-stroke" stroke-linecap="square" stroke-width="2">
                                            <path d="M1 7h12M7 1v12"/>
                                        </g>
                                    </svg>
                                </a>
                                <span class="field-error" i18n="@@error.valid_url" >Please provide valid URL</span>
                            </fieldset>
                        </form>
                    </div>

                    <div *ngFor="let link of links; index as i" class="new-proposal__fields--project-details__sidebar--contentInner link-container">
                        <a [attr.href]="link" target="_blank">{{ link }}</a>
                        <a (click)="removeLink(i)" href="javascript:void(0)" class="tu-icon-cancel cancel"><strong>x</strong></a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="new-proposal__controlsBTN align-left-content">
        <a href="javascript:void(0)" class="tu-btn transparent" (click)="triggerPrevious.emit()" i18n="@@button.back">Back</a>
        <a href="javascript:void(0)" class="tu-btn pink next_btn" (click)="submit()" i18n="@@button.next">Next</a>
    </div>
</form>